import React from "react";
import { ModalBody, ModalFooter, ModalHeader } from "../../Modal/Modal";
import { useState } from "react";
import { InfiniteEntryTable } from "../InfiniteEntryTable/InfiniteEntryTable";
import "./EntryPickerModal.css";
import Button from "../../Button/Button";
import Select from "../../Select/Select";
import { OpenEntryPickerModalArgs } from "../types";

export interface EntryPickerModalProps extends OpenEntryPickerModalArgs {
  closeModal?: () => void;
}

export const EntryPickerModal = (props: EntryPickerModalProps) => {
  const {
    getEntries,
    contentTypes,
    multiple,
    max,
    onSubmit,
    users,
    currentUserId,
    environments,
    locales,
    currentLocale,
    selectedEntries: value = [],
    closeModal,
  } = props;
  const [contentType, setContentType] = useState(() => {
    if (contentTypes) {
      return Object.values(contentTypes)[0];
    }
    return undefined;
  })
  const [selectedEntries, setSelectedEntries] = useState<Record<string, any>[]>(value);
  const [isShowingSelectedEntries, setIsShowingSelectedEntries] = useState(false);

  const choices = Object.values(contentTypes)?.map((item) => {
    return {
      label: item.title,
      value: item.uid,
    }
  });

  const addEntries = () => {
    if (onSubmit) {
      onSubmit(selectedEntries);
    }
    if (closeModal) {
      closeModal();
    }
  }

  return (
    <div className="entry-picker">
      <ModalHeader title="Select Entries" closeModal={closeModal} />
      <ModalBody>
        <div className="content-type-select">
          {!isShowingSelectedEntries ? (
            <div>
              <Select
                value={{ label: contentType.title, value: contentType.uid }}
                onChange={(data) => setContentType(contentTypes[data.value])}
                isSearchable={true}
                options={choices ?? []}
                version="v2"
                testId="entry-picker__content-type-select"
              />
            </div>
          ) : null}
          <Button
            buttonType="tertiary"
            className="selected-entries-button"
            onClick={() => setIsShowingSelectedEntries((prev) => !prev)}
            testId="entry-picker__selected-entries-button"
          >
            {!isShowingSelectedEntries ?
              `Show selected entries (${selectedEntries.length})` :
              `<- Back to entries list`
            }
          </Button>
        </div>
        <div>
          <InfiniteEntryTable
            contentType={contentType}
            showOnlySelectedEntries={isShowingSelectedEntries}
            users={users}
            currentUserId={currentUserId}
            fetchEntries={getEntries}
            allowMultipleSelection={multiple}
            selectedEntries={selectedEntries}
            setSelectedEntries={setSelectedEntries}
            environments={environments}
            locales={locales}
            currentLocale={currentLocale}
            maxSelect={max}
            displayBranchInfo={undefined}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={addEntries} testId="entry-picker__submit-button">Add Selected Entries</Button>
        <Button buttonType="tertiary" onClick={() => closeModal ? closeModal() : undefined} testId="entry-picker__cancel-button">
          Cancel
        </Button>
      </ModalFooter>
    </div>
  )
}